function Footer() {
  return (
    <footer className="footer">
      <p><strong>Radha Traders</strong></p>
      <p>Wholesale Supplier | Delhi NCR</p>
      <p>Since 2002</p>
      <p style={{ marginTop: "10px", fontSize: "14px", opacity: 0.7 }}>
        © 2026 All Rights Reserved
      </p>
    </footer>
  );
}

export default Footer;